function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("rect", {
  id: "Rectangle_3",
  "data-name": "Rectangle 3",
  width: 427.056,
  height: 37.511,
  transform: "translate(83 400.379)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "proxenta_x_brand_light",
  transform: "translate(-83 -400.379)"
}, React.createElement("g", {
  id: "Group_14",
  "data-name": "Group 14"
}, React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M337.674,437.037h7.973l2.809-7.973h13.391l2.707,7.973h8.174l-13.39-35.8h-8.073Zm17.5-26.978h.1L359.79,423.2h-9.277ZM319.65,437.037h7.875V407.852h10.73v-6.619H308.92v6.619h10.73v29.185Zm-48.034,0h7.371V413.068h.1l14.893,23.969h7.873v-35.8h-7.371v24.019h-.1l-14.944-24.019h-7.823Zm-36.176,0h27.18v-6.619H243.313v-8.775h17.351v-6.118H243.313v-7.673h18.906v-6.619H235.44Zm-79.021-17.751c0,10.33,6.569,18.6,17.6,18.6s17.6-8.273,17.6-18.6c0-10.631-6.569-18.9-17.6-18.9s-17.6,8.274-17.6,18.9m7.873,0c0-6.268,2.658-12.286,9.728-12.286s9.729,6.019,9.729,12.286c0,5.966-2.658,11.986-9.729,11.986s-9.728-6.02-9.728-11.986M118.96,437.037h7.873v-13.99h7.873c3.962,0,5.416,1.654,5.968,5.416.4,2.857.351,6.318,1.253,8.574H149.8c-1.454-1.955-1.354-6.217-1.5-8.475-.251-3.66-1.354-7.321-5.215-8.374v-.1c4.011-1.6,5.666-4.764,5.666-8.976,0-5.416-4.062-9.879-10.481-9.879H118.96Zm7.873-29.686h8.625c3.561,0,5.416,1.5,5.416,4.965,0,3.609-1.855,5.114-5.416,5.114h-8.625V407.351ZM83,437.037h7.873V424.2h8.274c8.977,0,12.387-5.666,12.387-11.483s-3.41-11.483-12.387-11.483H83Zm7.873-29.686h6.118c3.611,0,6.92.8,6.92,5.365s-3.309,5.365-6.92,5.365H90.873Z",
  fill: "#f8d9bf"
})), React.createElement("g", {
  id: "Group_13",
  "data-name": "Group 13",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M224.83,437.037h3.033s-3.408-4.516-6.3-8.914h-8.995c.529.8,1.831,2.736,2.176,3.252,3.778,5.662,3.753,5.662,10.087,5.662",
  fill: "#f8d9bf"
}))), React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M224.263,401.233h-5.085l-2.808,4.117-21.613,31.689h8.875L227.8,401.233Z",
  fill: "#f8d9bf"
}), React.createElement("g", {
  id: "Group_16",
  "data-name": "Group 16"
}, React.createElement("g", {
  id: "Group_15",
  "data-name": "Group 15",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M210.031,410.147c-1.135-1.658-2.035-2.942-2.555-3.626-2.01-2.8-3.287-5.288-7.46-5.288h-5.2s2.563,3.885,5.883,8.914Z",
  fill: "#f8d9bf"
}))), React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M425.77,400.379l-2.942,4.313-22.643,33.2h9.3l25.324-37.512Z",
  fill: "#c12e3a"
}), React.createElement("g", {
  id: "Group_21",
  "data-name": "Group 21"
}, React.createElement("g", {
  id: "Group_17",
  "data-name": "Group 17",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M416.188,409.718c-1.189-1.737-2.132-3.083-2.677-3.8-2.106-2.934-3.444-5.541-7.815-5.541h-5.448l6.163,9.339,12.434,18.833c.555.836,1.919,2.867,2.279,3.408,3.958,5.932,3.933,5.932,10.568,5.932h3.178s-3.57-4.73-6.6-9.34Z",
  fill: "#c12e3a"
})), React.createElement("g", {
  id: "Group_18",
  "data-name": "Group 18",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M505.359,425.547h.913V421.6l3.783-5.636h-1.087l-3.14,4.857-3.153-4.857h-1.087l3.771,5.636v3.944Zm-11.165-8.8h3.342v8.8h.912v-8.8h3.342v-.777h-7.6Zm-8.426,8.8h.912v-8.1h.026l5.583,8.1h1.021v-9.58H492.4v8.105h-.027l-5.582-8.105h-1.02Zm-7.945,0h6.683v-.777h-5.771v-3.784h5.341v-.779h-5.341v-3.462h5.7v-.777h-6.616v9.579Zm-5.381-4.937-3.449,4.937h1.033l2.952-4.226,2.912,4.226h1.1l-3.462-4.91,3.273-4.67h-1.02l-2.8,4.012-2.71-4.012h-1.074Zm-12.776.147c0,2.631,1.5,4.993,4.523,4.993s4.509-2.361,4.509-4.993-1.5-4.992-4.509-4.992-4.523,2.361-4.523,4.992m.913,0c0-2.094,1.073-4.214,3.61-4.214s3.6,2.12,3.6,4.214-1.073,4.213-3.6,4.213-3.61-2.118-3.61-4.213m-9.352,4.79h.911v-4.253H455.6c1.719-.066,1.853,1.423,1.92,2.765a4.314,4.314,0,0,0,.255,1.488h1.007a5.374,5.374,0,0,1-.443-2.455c-.066-1.154-.429-1.986-1.677-2.16v-.027a2.3,2.3,0,0,0,1.865-2.442c0-1.73-1.342-2.495-2.912-2.495h-4.388v9.579Zm.911-8.8h3.409c1.382,0,2.066.726,2.066,1.906a1.9,1.9,0,0,1-2.066,1.865h-3.409Zm-9.367,8.8h.913v-4.105h3.341a2.739,2.739,0,1,0,0-5.474h-4.254Zm.914-8.8h3.14a1.967,1.967,0,1,1,0,3.919h-3.14Z",
  fill: "#f8d9bf"
})), React.createElement("g", {
  id: "Group_19",
  "data-name": "Group 19",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M482.8,410.162h1.061l3.556-9.581h-.966l-3.087,8.575h-.027l-3.113-8.575h-.979Zm-12.949-4.791c0,2.631,1.5,4.993,4.521,4.993s4.509-2.362,4.509-4.993-1.5-4.992-4.509-4.992-4.521,2.362-4.521,4.992m.911,0c0-2.093,1.074-4.213,3.61-4.213s3.6,2.12,3.6,4.213-1.073,4.214-3.6,4.214-3.61-2.121-3.61-4.214m-9.1,4.791h.913v-3.288l1.838-1.7,3.986,4.992h1.181l-4.482-5.623,4.28-3.958h-1.233l-5.569,5.153v-5.153h-.913v9.581Zm-10.454-4.791c0,2.631,1.5,4.993,4.523,4.993s4.509-2.362,4.509-4.993-1.5-4.992-4.509-4.992-4.523,2.362-4.523,4.992m.913,0c0-2.093,1.073-4.213,3.61-4.213,2.521,0,3.6,2.12,3.6,4.213s-1.074,4.214-3.6,4.214-3.61-2.121-3.61-4.214m-9.354,4.791h.913v-4.254h3.462c1.718-.066,1.852,1.423,1.919,2.765a4.274,4.274,0,0,0,.255,1.489h1.007a5.378,5.378,0,0,1-.443-2.456c-.066-1.153-.43-1.985-1.678-2.16v-.026a2.3,2.3,0,0,0,1.866-2.442c0-1.73-1.342-2.5-2.912-2.5h-4.389Zm.914-8.8h3.408c1.382,0,2.066.725,2.066,1.906a1.9,1.9,0,0,1-2.066,1.864h-3.408Z",
  fill: "#f8d9bf"
})), React.createElement("g", {
  id: "Group_20",
  "data-name": "Group 20",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M448.693,437.445v.445h-5.384c.094-1.5,1.288-2.342,2.47-3.125s2.341-1.521,2.341-2.891a1.879,1.879,0,0,0-1.989-1.814c-1.464,0-2.178,1.088-2.178,2.48h-.444c.094-1.953.96-2.867,2.552-2.867a2.215,2.215,0,0,1,2.5,2.213c0,2.832-4.506,3.521-4.692,5.559h4.82Z",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M449.6,433.852c0-1.93.6-4.178,2.926-4.178s2.926,2.248,2.926,4.178-.6,4.18-2.926,4.18S449.6,435.783,449.6,433.852Zm5.407,0c0-1.625-.468-3.791-2.48-3.791s-2.481,2.166-2.481,3.791.468,3.793,2.481,3.793S455.011,435.479,455.011,433.852Z",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M456.11,433.852c0-1.93.6-4.178,2.926-4.178s2.926,2.248,2.926,4.178-.6,4.18-2.926,4.18S456.11,435.783,456.11,433.852Zm5.407,0c0-1.625-.468-3.791-2.48-3.791s-2.481,2.166-2.481,3.791.468,3.793,2.481,3.793S461.517,435.479,461.517,433.852Z",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M463.376,435.9a2,2,0,0,0,2.024,1.744c2.212,0,2.527-2.656,2.527-4.107l-.023-.023a2.417,2.417,0,0,1-2.352,1.639,2.74,2.74,0,0,1,0-5.479c1.24,0,2.82.551,2.82,3.781,0,1.977-.479,4.576-2.973,4.576a2.288,2.288,0,0,1-2.47-2.131h.447Zm4.459-3.511a2.282,2.282,0,1,0-4.564,0,2.328,2.328,0,0,0,2.282,2.377A2.285,2.285,0,0,0,467.835,432.389Z",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M472.853,434.93v-.445h2.505v.445Z",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M485.338,437.445v.445h-5.384c.094-1.5,1.288-2.342,2.47-3.125s2.341-1.521,2.341-2.891a1.879,1.879,0,0,0-1.989-1.814c-1.464,0-2.178,1.088-2.178,2.48h-.444c.094-1.953.96-2.867,2.552-2.867a2.215,2.215,0,0,1,2.5,2.213c0,2.832-4.506,3.521-4.692,5.559h4.82Z",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_17",
  "data-name": "Path 17",
  d: "M486.249,433.852c0-1.93.6-4.178,2.926-4.178s2.926,2.248,2.926,4.178-.6,4.18-2.926,4.18S486.249,435.783,486.249,433.852Zm5.406,0c0-1.625-.468-3.791-2.48-3.791s-2.481,2.166-2.481,3.791.468,3.793,2.481,3.793S491.655,435.479,491.655,433.852Z",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_18",
  "data-name": "Path 18",
  d: "M496.3,437.891h-.445v-7.209a3.439,3.439,0,0,1-2.165,1.029v-.387a3.042,3.042,0,0,0,2.212-1.51h.4Z",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M500.021,435.9a2,2,0,0,0,2.024,1.744c2.212,0,2.527-2.656,2.527-4.107l-.023-.023a2.417,2.417,0,0,1-2.352,1.639,2.74,2.74,0,0,1,0-5.479c1.24,0,2.82.551,2.82,3.781,0,1.977-.479,4.576-2.973,4.576a2.288,2.288,0,0,1-2.47-2.131h.447Zm4.458-3.511a2.282,2.282,0,1,0-4.564,0,2.328,2.328,0,0,0,2.282,2.377A2.285,2.285,0,0,0,504.479,432.389Z",
  fill: "#fff"
}))));

var SvgLogoCele = function SvgLogoCele(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 427.056,
    height: 37.512,
    viewBox: "0 0 427.056 37.512",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoCele, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-cele.79a606a0.svg";
export { ForwardRef as ReactComponent };